import { useAppDispatch } from "hooks/hooks";
import classesEditNote from "../styles/EditNotePopover.module.scss";
import { debounce } from "lodash";
import { useMemo } from "react";

interface IProps {
  onNoteUpdate: Function;
  defaultValue?: string;
  readOnlyInput?: boolean;
}

const EditNotePopover = ({
  onNoteUpdate,
  defaultValue,
  readOnlyInput }: IProps) => {
  const dispatch = useAppDispatch();

  const delayedNoteUpdate = useMemo(
    () =>
      debounce(async (note: string) => {
        try {
          onNoteUpdate(note);
        } catch (error) {
          console.log(error);
        }
      }, 1000),
    [dispatch]
  );

  return (
    <div className={`${classesEditNote.popoverContent}`}>
      <textarea
        readOnly={readOnlyInput === true}
        onChange={(event) => delayedNoteUpdate(event.target.value)}
        defaultValue={defaultValue} />
    </div>
  );
}
export default EditNotePopover;
